/******************************************************************
 * FILE: src/pages/DashboardPage.jsx
 ******************************************************************/
import React, { useEffect, useMemo, useState,  useContext ,useLayoutEffect,
  useRef,} from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Button,
  Stack,
  Chip,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Divider,
  TextField,
  InputAdornment,
  Avatar,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import HistoryIcon from "@mui/icons-material/History";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import ThermostatOutlinedIcon from "@mui/icons-material/ThermostatOutlined";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import HeartBrokenOutlinedIcon from "@mui/icons-material/HeartBrokenOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PetsOutlinedIcon from "@mui/icons-material/PetsOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import NotificationDrawer from "../components/NotificationDrawer";


import { getKumesler, getDonemler, getKumesKartiBilgileri, getKumesKartiHindiBilgileri, } from "../services/api";


import { LineChart, Line, ResponsiveContainer } from "recharts";
import sabahGorsel from "../assets/images/Sabah-kumes.png";
import oglenGorsel from "../assets/images/oglen_kumes.png";
import aksamGorsel from "../assets/images/aksam_kumes.png";


const ORANGE = "#FF7A2B";
const ORANGE_HOVER = "#E66A20";

// const hanldeGoDetail =(kumes)=>{
//   if (kumes.DONEM_ID) return ;
//   navigate (`/kumes/${kumes.KUMES_ID}/donem/${kumes.DONEM_ID}`);
// }

export default function UretimDonemiPage() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [kumesler, setKumesler] = useState([]);
  const [ureticiId, setUreticiId] = useState(null); // ✅ EKLE
  const [error, setError] = useState("");

  const [q, setQ] = useState("");
  const [profileAnchor, setProfileAnchor] = useState(null);
  const [notifCount] = useState(0);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyKumes, setHistoryKumes] = useState(null);
  const [historyDonemler, setHistoryDonemler] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyError, setHistoryError] = useState("");
  const { user, cihazTokenId ,handleLogout } = useContext(AuthContext);
  const kullaniciId = user?.KULLANICI_ID || null;



useEffect(() => {
  // console.log("PAGE user:", user);
  // console.log("PAGE kullaniciId:", kullaniciId);
  // console.log("PAGE cihazTokenId:", cihazTokenId);
  
}, [user, kullaniciId, cihazTokenId]);

 const headerRef = useRef(null);
  const [headerH, setHeaderH] = useState(0);

  useLayoutEffect(() => {
    const el = headerRef.current;
    if (!el) return;

    const calc = () => setHeaderH(el.getBoundingClientRect().height || 0);
    calc();

    const ro = new ResizeObserver(calc);
    ro.observe(el);

    window.addEventListener("resize", calc);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", calc);
    };
  }, []);

const initials = useMemo(() => {
  const ad = (user?.KULLANICI_ADI || user?.ADI || "").trim();
  const soyad = (user?.KULLANICI_SOYADI || user?.SOYADI || "").trim();

  const a = ad ? ad[0].toUpperCase() : "";
  const s = soyad ? soyad[0].toUpperCase() : "";

  // sadece ad varsa "A", ad+soyad varsa "AS"
  return (a + s) || "U";
}, [user]);


  useEffect(() => {
    const fetchKumesler = async () => {
      try {
        setLoading(true);
        const res = await getKumesler();
        const kumesData = Array.isArray(res?.data?.data) ? res.data.data : [];
        
       // console.log("📊 getKumesler tam response:", res?.data); // ✅ KONTROL
       // console.log("📋 kumesData:", kumesData); // ✅ KONTROL
        
        if (kumesData.length > 0) {
          // console.log("🔍 İlk kümes:", kumesData[0]); // ✅ KONTROL
          //  console.log("🔑 URETICI_ID:", kumesData[0]?.URETICI_ID); // ✅ KONTROL
        }
        
        setKumesler(kumesData);
      } catch (err) {
       // console.error("❌ Kumesler yüklenemedi:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchKumesler();
  }, []);

  const handleGoDetail = async (kumes) => {
    if (!kumes?.DONEM_ID) return;

   // console.log("🔍 handleGoDetail kumes:", kumes); // ✅ KONTROL
    // console.log("🔑 kumes.URETICI_ID:", kumes?.URETICI_ID); // ✅ KONTROL

    const isIntegrated = !!kumes.ENTEGRASYON_KODU || !!kumes.URETICI_ENTEGRASYON_KODU;
    const hayvanCinsId = kumes.HAYVAN_CINS_ID;
    const ureticiId = kumes.URETICI_ID; // ✅ KONTROL ET

    // console.log("📤 Navigate edilecek state:", {
    //   ureticiId,
    //   hayvanCinsId,
    //   isIntegrated,
    //   kumesAdi: kumes.KUMES_ADI,
    // }); 

    try {
      let detailData;
      if (hayvanCinsId === 1) {
        const res = await getKumesKartiBilgileri(kumes.DONEM_ID);
        detailData = res?.data?.data || res?.data;
      } else if (hayvanCinsId === 2) {
        const res = await getKumesKartiHindiBilgileri(kumes.DONEM_ID);
        detailData = res?.data?.data || res?.data;
      } else {
        detailData = {};
      }

      navigate(`/kumes/${kumes.KUMES_ID}/donem/${kumes.DONEM_ID}`, {
        state: {
          hayvanCinsId: hayvanCinsId,
          isIntegrated,
          initialData: {
            kumesAdi: kumes.KUMES_ADI,
            donemId: kumes.DONEM_ID,
            kacinciGun: kumes.KACINCI_GUN,
            sonOlum: kumes.SON_OLUM,
            sonSicaklik: kumes.SON_SICAKLIK,
            sonNem: kumes.SON_NEM,
            CINSIYET_ID: kumes.CINSIYET_ID,
            ENTEGRE_SIRKET_ID: kumes.ENTEGRE_SIRKET_ID,
            KACINCI_GUN: kumes.KACINCI_GUN,
            AKTIF_DONEM_PROJE_KODU: kumes.AKTIF_DONEM_PROJE_KODU,
            ENTEGRASYON_KODU: kumes.ENTEGRASYON_KODU,
            URETICI_ID: ureticiId,
            URETIM_KAPANDI_MI: kumes.URETIM_KAPANDI_MI,
            SON_BITIS_SAYI: kumes.SON_BITIS_SAYI,
            DONEM_NO: kumes.DONEM_NO,
            
            ...detailData,
          },
        },
      });
    } catch (error) {
      // console.error("❌ Detay verileri hatası:", error);
      navigate(`/kumes/${kumes.KUMES_ID}/donem/${kumes.DONEM_ID}`, {
        state: {
          hayvanCinsId: hayvanCinsId,
          isIntegrated,
          initialData: {
            kumesAdi: kumes.KUMES_ADI,
            donemId: kumes.DONEM_ID,
            URETICI_ID: ureticiId,
            URETIM_KAPANDI_MI: kumes.URETIM_KAPANDI_MI,
            DONEM_NO: kumes.DONEM_NO,
          },
        },
      });
    }
  };

  const handleOpenHistory = async (kumes, e) => {
    e?.preventDefault();
    e?.stopPropagation();

    setHistoryOpen(true);
    setHistoryKumes(kumes || null);
    setHistoryDonemler([]);
    setHistoryError("");

    if (!kumes?.KUMES_ID) return;

    try {
      setHistoryLoading(true);
      const res = await getDonemler(kumes.KUMES_ID);
      const arr = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : [];
      const closed = arr.filter((d) => d.URETIM_KAPANDI_MI === "E");
      setHistoryDonemler(closed);
    } catch (e) {
      setHistoryError(e?.response?.data?.message || e?.message || "Dönemler alınamadı.");
    } finally {
      setHistoryLoading(false);
    }
  };



  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return kumesler;

    return kumesler.filter((k) => {
      const hayvan = `${k.HAYVAN_TANIM_ADI || ""}`.toLowerCase();
      const ad = `${k.KUMES_ADI || ""}`.toLowerCase();
      const il = `${k.IL_ADI || ""}`.toLowerCase();
      const ilce = `${k.ILCE_ADI || ""}`.toLowerCase();
      const firma = `${k.SIRKET_ADI || ""}`.toLowerCase();
      return (
        ad.includes(s) ||
        hayvan.includes(s) ||
        il.includes(s) ||
        ilce.includes(s) ||
        firma.includes(s)
      );
    });
  }, [kumesler, q]);

  const sortedKumesler = useMemo(() => {
  return [...filtered].sort((a, b) => {
    const aBosMu = String(a.KACINCI_GUN || "").toLowerCase().includes("kümes boş");
    const bBosMu = String(b.KACINCI_GUN || "").toLowerCase().includes("kümes boş");

    if (aBosMu === bBosMu) return 0;
    if (aBosMu) return 1;   // a boşsa alta at
    return -1;              // b boşsa b alta gitsin
  });
}, [filtered]);



  const activeDonemCount = useMemo(() => {
    return kumesler.filter(k => k.DONEM_ID && (k.URETIM_KAPANDI_MI || "H") !== "E").length;
  }, [kumesler]);

  const activePercentage = kumesler.length > 0 
    ? Math.round((activeDonemCount / kumesler.length) * 100) 
    : 0;

  // Hayvan türü dağılımı
  const hayvanDagilimi = useMemo(() => {
    const dagilim = {};
    kumesler.forEach(k => {
      const tur = k.HAYVAN_TANIM_ADI || "Bilinmeyen";
      dagilim[tur] = (dagilim[tur] || 0) + 1;
    });
    return dagilim;
  }, [kumesler]);
  const hayvanTop2 = useMemo(() => {
  const entries = Object.entries(hayvanDagilimi || {});
  entries.sort((a, b) => b[1] - a[1]);

  const total = Math.max(kumesler.length, 1);
  const top = entries.slice(0, 2).map(([tur, adet]) => ({
    tur,
    adet,
    yuzde: Math.round((adet / total) * 100),
  }));

  const otherCount = entries.slice(2).reduce((sum, [, adet]) => sum + adet, 0);
  if (otherCount > 0) {
    top.push({
      tur: "Diğer",
      adet: otherCount,
      yuzde: Math.round((otherCount / total) * 100),
    });
  }
  return top;
}, [hayvanDagilimi, kumesler.length]);


  // Toplam aktif kamera sayısı
  const toplamKameraSayisi = useMemo(() => {
    return kumesler.reduce((total, k) => {
      return total + (Number(k.AKTIF_KAMERA_SAY) || 0);
    }, 0);
  }, [kumesler]);

  const iotAktifCount = useMemo(() => {
  return kumesler.filter(k => k.IOT_DURUMU === "E").length;
}, [kumesler]);

const iotYokCount = useMemo(() => {
  return kumesler.filter(k => (k.IOT_DURUMU || "H") !== "E").length;
}, [kumesler]);

const iotPercentage = useMemo(() => {
  const total = Math.max(kumesler.length, 1);
  return Math.round((iotAktifCount / total) * 100);
}, [iotAktifCount, kumesler.length]);


const kpiCardSx = {
  width: "100%",
  minWidth: 0,
  p: { xs: 1.6, sm: 1.8, md: 2.2 },
  borderRadius: 4,
  minHeight: { xs: 150, sm: 160, md: 170 },
  bgcolor: "#fff",
  border: "1px solid #E5E7EB",
  boxShadow: "0 8px 22px rgba(15,23,42,0.06)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};

const kpiTitleSx = {
  fontWeight: 900,
  fontSize: { xs: 16, sm: 17, md: 18 },
  color: "#3f4044",
  lineHeight: 1.2,
  minHeight: { xs: 38, sm: 42 },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
};

const kpiBodySx = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,          // ✅ başlık sabit kalır, içerik alanı kalan yeri doldurur
  mt: 1.2,          // ✅ başlık ile içerik arası her kartta aynı
};

  const openProfile = Boolean(profileAnchor);

  const headerIconBtnSx = {
  width: 42,
  height: 42,
  border: "1px solid rgba(0,0,0,0.08)",
  borderRadius: 2.5,
  bgcolor: "#fff",
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  transition: "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 10px 22px rgba(0,0,0,0.10)",
    borderColor: "rgba(0,0,0,0.14)",
    bgcolor: "#fff",
  },
};

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#eeeded",
        p: { xs: 1.5, md: 3 },
      }}
    >
      {/* HEADER */}
      <Paper
        ref={headerRef}
        elevation={0}
        sx={{
          borderRadius: 4,
          p: { xs: 1.5, md: 2 },
          mb: 2,
          border: "1px solid rgba(255, 145, 0, 0.6)",
          background: "linear-gradient(180deg, #FFFFFF 0%, #FBFBFD 100%)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >


          <Box sx={{ flex: "1 1 280px" }}>
            <TextField
              fullWidth
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Kümes adı, il/ilçe, hayvan cinsi..."
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: 3, bgcolor: "#fff", ":hover": { bgcolor: "#f5f5f5" }, textAlign: "center" ,justifyContent: "center", alignItems: "center" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}>
                <NotificationDrawer
                  kullaniciId={kullaniciId}
                  cihazTokenId={cihazTokenId}
                  topOffset={headerH}
                  buttonSx={headerIconBtnSx}
                />


            <Tooltip title="Hesap">
              <IconButton
                onClick={(e) => setProfileAnchor(e.currentTarget)}
                sx={headerIconBtnSx}
              >
                <AccountCircleOutlinedIcon sx={{ fontSize: 22 }} />
              </IconButton>
            </Tooltip>

            <Menu
              anchorEl={profileAnchor}
              open={openProfile}
              onClose={() => setProfileAnchor(null)}
              PaperProps={{ sx: { borderRadius: 3, minWidth: 240, p: 0.5 } }}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  setProfileAnchor(null);
                  navigate("/uretici-bilgileri");
                }}
              >
                <Avatar sx={{ width: 24, height: 24, mr: 1, bgcolor: ORANGE, fontSize: 12, fontWeight: 900 }}>
                       {initials}
                  </Avatar>
                Hesap Bilgilerim
              </MenuItem>

              <Divider sx={{ my: 0.5 }} />

                <MenuItem
                  onClick={() => {
                      setProfileAnchor(null);
                      handleLogout(true); // ✅ gerçek logout
                    }}
                    sx={{ color: ORANGE, fontWeight: 700 }}
                  >
                    <LogoutIcon fontSize="small" style={{ marginRight: 8 }} />
                    Çıkış Yap
                 </MenuItem>
             </Menu>
          </Box>
        </Box>
      </Paper>

      {/* KARŞILAMA KARTI - YENİ TASARIM */}
{/* HERO - Modern Gradient Arka Plan */}
  <Paper
    elevation={0}
    sx={{
      textAlign: "center",
      alignContent: "center",
      borderRadius: 4,
      p: { xs: 2, md: 2.5 },
      mb: 2,
      bgcolor: "rgba(157, 159, 161, 0.35)",
      border: "1px solid #E5E7EB",
      overflow: "hidden",
      position: "relative",


      "& > *":{ position: "relative", zIndex: 1},

"&::before": {
  content: '""',
  position: "absolute",
  inset: 0,
  backgroundImage: `url(${require("../assets/images/kumes_bgimg_2.png")})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "85% center",
  opacity: 0.14,
  filter: "grayscale(1) contrast(1.05)",
  pointerEvents: "none",
  zIndex: 0,
},
"&::after": {
  content: '""',
  position: "absolute",
  inset: 0,
  // background:
  //   "linear-gradient(90deg, rgba(248,250,252,1) 0%, rgba(248,250,252,1) 45%, rgba(248,250,252,0.80) 70%, rgba(248,250,252,0.35) 100%)",
  pointerEvents: "none",
  zIndex: 0,
},
"& > *": { position: "relative", zIndex: 1 },
}
}
>
 

  {/* üst metin */}
  <Box sx={{ position: "relative",  textAlign: "center", mb: 1 }}>
    <Typography
      variant="h3"
      sx={{ fontWeight: 900, lineHeight: 1.05, letterSpacing: -0.5 ,color: "#0F172A"}}
    >
      {getGreeting()}  🐔
    </Typography>

    <Typography sx={{ opacity: 0.95, mt: 0.8, fontSize: 15,color: "#64748B" }}>
      Sisteminizde toplam <strong>{kumesler.length}</strong> kümes bulunuyor.
    </Typography>

    {/* chips */}
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mt: 1.6,
        flexWrap: "wrap",
        gap: 1,
        justifyContent: "center",
      }}
    >
      <Chip
        label={`▶ Aktif Dönem: ${activeDonemCount}/${kumesler.length}`}
        sx={{
          bgcolor: "rgba(249,115,22,0.10)",
          color: "#C2410C",
          borderRadius: 3,
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(249,115,22,0.18)",
          fontWeight: 800,
        }}
      />
      <Chip
        label={`📹 Aktif Kamera: ${toplamKameraSayisi}`}
        sx={{
          fontWeight: 800,
          borderRadius: 3,
          backdropFilter: "blur(10px)",
          bgcolor: "#F1F5F9",
          color: "#0F172A",
          border: "1px solid #E2E8F0"
        }}
      />
      <Chip
        label={`🐓 Tür Çeşidi: ${Object.keys(hayvanDagilimi || {}).length}`}
        sx={{
          fontWeight: 800,
          borderRadius: 3,
          backdropFilter: "blur(10px)",
          bgcolor: "#F1F5F9",
          color: "#0F172A",
          border: "1px solid #E2E8F0"

        }}
      />
    </Stack>

    {/* 3 kart: TEK SATIR */}
  <Box
  sx={{
    mt: 2,
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr 1fr",
      lg: "repeat(4, minmax(0, 1fr))",
    },
    gap: { xs: 1.5, sm: 2, md: 2.5 },
    alignItems: "stretch",
  }}
>
      {/* Kart 1: Aktif Kamera */}
      <Paper
        elevation={0}
        sx={kpiCardSx}
      >
          <Typography sx={kpiTitleSx}>
          Aktif Kamera
        </Typography>
        <Box sx={kpiBodySx}> 
            <Typography sx={{ fontWeight: 900, fontSize: 64, lineHeight: 1, mt: 1,color: ORANGE}}>
              {toplamKameraSayisi}
            </Typography>

            <Chip
              size="small"
              label={toplamKameraSayisi > 0 ? "📹 İzleme aktif" : "📷 Kamera yok" }
              sx={{
                mt: 1.6,
                bgcolor: toplamKameraSayisi > 0
                  ? "rgba(196, 139, 35, 0.25)"
                  : "rgba(255,255,255,0.15)",
                color: "#000000",
                fontWeight: 900,
                borderRadius: 3,
              }}
            />
        </Box>
      </Paper>

      {/* Kart 2: Hayvan Türü Dağılımı */}
      <Paper
        elevation={0}
        sx={kpiCardSx}
      >
          <Typography sx={kpiTitleSx}>
            Hayvan Türü Dağılımı
          </Typography>


   <Box sx={kpiBodySx}>
        <Box sx={{ mt: 1.6 }}>
          {Object.entries(hayvanDagilimi)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 3)
            .map(([tur, adet]) => {
              const yuzde = kumesler.length
                ? Math.round((adet / kumesler.length) * 100)
                : 0;

              const emoji = tur.includes("HİNDİ")
                ? "🦃"
                : tur.includes("TAVUK")
                ? "🐔"
                : "🐓";

              return (
                <Box key={tur} sx={{ mb: 1.6 }}>
                  <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.6 }}>
                    <Typography sx={{ fontWeight: 800, opacity: 0.95 }}>
                      {emoji} {tur} {adet} kümes (%{yuzde})
                    </Typography>
                  </Stack>

                  <LinearProgress
                    variant="determinate"
                    value={yuzde}
                    sx={{
                      height: 10,
                      borderRadius: 6,
                      bgcolor: "rgba(255,255,255,0.25)",
                      "& .MuiLinearProgress-bar": {
                        bgcolor: "#ff7b00",
                        borderRadius: 6,
                      },
                    }}
                  />
                </Box>
              );
            })}
         </Box>

         <Chip
            size="small"
            label={`${kumesler.length} kümes`}
          sx={{
            mt: 1.6,
            bgcolor: toplamKameraSayisi > 0
              ? "rgba(196, 139, 35, 0.25)"
              : "rgba(255,255,255,0.15)",
            color: "#000000",
            fontWeight: 900,
            borderRadius: 3,
          }}
          />
  </Box>
      </Paper>

      {/* Kart 3: Aktif Dönem Durumu */}
        <Paper
          elevation={0}
          sx={kpiCardSx}
        >
          <Typography sx={kpiTitleSx}>
            Aktif Dönem Durumu
          </Typography>


   <Box sx={kpiBodySx}>

          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{ mt: 1.6 }}
          >
            {/* Donut */}
            <Box sx={{ position: "relative", width: 84, height: 84 }}>
              <CircularProgress
                variant="determinate"
                value={100}
                size={84}
                thickness={6}
                sx={{ color: "#E5E7EB" }}     // ✅ arka halka gri
              />
              <CircularProgress
                variant="determinate"
                value={activePercentage}
                size={84}
                thickness={6}
                sx={{ color: ORANGE, position: "absolute", left: 0, top: 0 }} // ✅ dolu kısım turuncu
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Typography sx={{ fontWeight: 900, fontSize: 18, color: "#111827" }}>
                  {activePercentage}%
                </Typography>
              </Box>
            </Box>

            {/* Metin alanı */}
            <Box sx={{ textAlign: "left" }}>
              <Typography sx={{ fontWeight: 900, fontSize: 34, lineHeight: 1, color: "#111827" }}>
                {activeDonemCount}/{kumesler.length}{" "}
                <span style={{ fontSize: 14, fontWeight: 800, color: "rgba(15,23,42,0.65)" }}>
                  aktif
                </span>
              </Typography>

              <Chip
                size="small"
                label="● Çalışıyor"
                sx={{
                  mt: 1.1,
                  bgcolor: "rgba(196, 139, 35, 0.25)", // ✅ ilk iki kartla aynı vibe
                  color: "#111827",
                  fontWeight: 900,
                  borderRadius: 3,
                }}
              />

              <Typography sx={{ mt: 1.0, fontSize: 12, color: "rgba(15,23,42,0.65)", fontWeight: 700 }}>
                Kapalı dönem: {kumesler.filter(k => (k.URETIM_KAPANDI_MI || "H") === "E").length}
              </Typography>
            </Box>
          </Stack>
  </Box>
        </Paper>



          <Paper
                  elevation={0}
                  sx={kpiCardSx}
                >
                <Typography sx={kpiTitleSx}>
                  IoT Durumu
                </Typography>


         <Box sx={kpiBodySx}>  
                <Typography sx={{ fontWeight: 900, fontSize: 64, lineHeight: 1, mt: 1, color: ORANGE }}>
                  {iotAktifCount}
                </Typography>

                <Typography sx={{ mt: 0.6, fontSize: 13, fontWeight: 800, color: "rgba(15,23,42,0.65)" }}>
                  {kumesler.length} kümesin {iotAktifCount} tanesinde IoT aktif
                </Typography>

                <Chip
                  size="small"
                  label={iotAktifCount > 0 ? `🔌 IoT Aktif (%${iotPercentage})` : "🚫 IoT Aktif Değil"}
                  sx={{
                    mt: 1.4,
                    bgcolor: iotAktifCount > 0 ? "rgba(196, 139, 35, 0.25)" : "rgba(15,23,42,0.08)",
                    color: "#111827",
                    fontWeight: 900,
                    borderRadius: 3,
                  }}
                />
           </Box>
        </Paper>
    </Box>
  </Box>
</Paper>



      {/* CONTENT */}
      {loading ? (
        <Box sx={{ display: "grid", placeItems: "center", mt: 6 }}>
          <CircularProgress sx={{ color: ORANGE }} />
          <Typography sx={{ mt: 2, color: "text.secondary" }}>
            Kümesler yükleniyor...
          </Typography>
        </Box>
      ) : error ? (
        <Paper
          sx={{
            p: 2,
            borderRadius: 4,
            border: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          <Typography color="error" sx={{ fontWeight: 700 }}>
            {error}
          </Typography>
        </Paper>
      ) : filtered.length === 0 ? (
        <Paper
          sx={{
            p: 3,
            borderRadius: 4,
            border: "1px solid rgba(0,0,0,0.06)",
          }}

        >
          <Typography sx={{ fontWeight: 800 }}>Kümes bulunamadı</Typography>
          <Typography sx={{ color: "text.secondary", mt: 1 }}>
            Arama filtresini temizle ya da kullanıcıya kümes tanımla.
          </Typography>
        </Paper>
      ) : (
        <>

          <Box
            sx={{
              width: "100%",
              maxWidth: 2600,
              mx: "auto",
              mt: 3,
              px: { xs: 0, md: 1 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(2, minmax(0, 1fr))",
              },
              gap: { xs: 2, md: 4 },
              alignItems: "stretch",
            }}
          >
            {sortedKumesler.map((kumes) => (
              <Box key={kumes.KUMES_ID} sx={{ display: "flex" }}>
                <KumesCard
                  kumes={kumes}
                  chartData={[]}
                  onGoDetail={() => handleGoDetail(kumes)}
                  onGoHistory={(e) => handleOpenHistory(kumes, e)}
                />
              </Box>
            ))}
          </Box>


        </>
      )}

      {/* GEÇMİŞ DÖNEMLER DIALOG - DEĞIŞMEZ */}
      <Dialog
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 4, p: 0 } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <HistoryIcon sx={{ color: ORANGE }} />
            <Typography sx={{ fontWeight: 900, fontSize: 18 }}>
              Geçmiş Dönemler
            </Typography>
          </Stack>
          <Typography sx={{ mt: 0.6, color: "text.secondary", fontSize: 13 }}>
            {historyKumes
              ? `${fmt(historyKumes.KUMES_ADI)} • ${fmt(historyKumes.IL_ADI)} / ${fmt(historyKumes.ILCE_ADI)}`
              : "Lütfen bir kümes seçin."}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ pt: 1, pb: 2 }}>
          {historyLoading && (
            <Box sx={{ display: "grid", placeItems: "center", py: 4 }}>
              <CircularProgress sx={{ color: ORANGE }} />
              <Typography sx={{ mt: 1.5, color: "text.secondary" }}>
                Dönemler yükleniyor...
              </Typography>
            </Box>
          )}

          {!historyLoading && historyError && (
            <Paper
              sx={{
                p: 2,
                borderRadius: 3,
                border: "1px solid rgba(0,0,0,0.06)",
              }}
            >
              <Typography color="error" sx={{ fontWeight: 700 }}>
                {historyError}
              </Typography>
            </Paper>
          )}

          {!historyLoading && !historyError && historyKumes && historyDonemler.length === 0 && (
            <Paper
              sx={{
                p: 2,
                borderRadius: 3,
                border: "1px solid rgba(0,0,0,0.06)",
                bgcolor: "#fff",
              }}
            >
              <Typography sx={{ fontWeight: 800 }}>
                Geçmiş dönem bulunamadı
              </Typography>
              <Typography sx={{ mt: 0.6, color: "text.secondary" }}>
                Bu kümes için kapalı dönem yok.
              </Typography>
            </Paper>
          )}

          {!historyLoading && !historyError && historyDonemler.length > 0 && (
            <List sx={{ p: 0 }}>
              {historyDonemler.map((d) => (
                <ListItem
                  key={d.DONEM_ID}
                  disablePadding
                  sx={{
                    mb: 1.2,
                    borderRadius: 3,
                    border: "1px solid rgba(0,0,0,0.06)",
                    overflow: "hidden",
                    bgcolor: "#fff",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
                  }}
                >
<ListItemButton
  onClick={() => {
    const isIntegrated =
      !!historyKumes?.ENTEGRASYON_KODU || !!historyKumes?.URETICI_ENTEGRASYON_KODU;

    const canEdit = !isIntegrated;

    setHistoryOpen(false);

    navigate(`/kumes/${historyKumes.KUMES_ID}/donem/${d.DONEM_ID}`, {
      state: {
        hayvanCinsId: historyKumes.HAYVAN_CINS_ID,
        isIntegrated,
        viewMode: "history",
        canEdit,
        initialData: {
          kumesAdi: historyKumes.KUMES_ADI,
          donemId: d.DONEM_ID,
          URETICI_ID: historyKumes.URETICI_ID,
        },
      },
    });
  }}
>
                    <ListItemText
                      primary={
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography sx={{ fontWeight: 900 }}>
                            {fmt(d.KUMES_DONEM_ADI)}
                          </Typography>
                          <Stack direction="row" alignItems="center" spacing={0.8}>
                            <Box
                              sx={{
                                width: 26,
                                height: 26,
                                borderRadius: 1.5,
                                display: "grid",
                                placeItems: "center",
                                bgcolor: "rgba(244,67,54,0.12)",
                                color: "#d32f2f",
                                border: "1px solid rgba(244,67,54,0.18)",
                              }}
                            >
                              <LockOutlinedIcon sx={{ fontSize: 16 }} />
                            </Box>
                            <Chip
                              size="small"
                              label="Kapalı"
                              sx={{
                                bgcolor: "rgba(244,67,54,0.12)",
                                color: "#d32f2f",
                                fontWeight: 800,
                                borderRadius: 2,
                              }}
                            />
                          </Stack>
                        </Stack>
                      }
                      secondary={
                        <Stack direction="row" spacing={1} sx={{ mt: 0.8, flexWrap: "wrap" }}>
                          <Chip
                            size="small"
                            label={`Dönem No: ${fmt(d.DONEM_NO)}`}
                            sx={{
                              bgcolor: "rgba(0,0,0,0.04)",
                              fontWeight: 700,
                              borderRadius: 2,
                            }}
                          />
                          <Chip
                            size="small"
                            label={`Hayvan Cins ID: ${fmt(d.HAYVAN_CINS_ID)}`}
                            sx={{
                              bgcolor: "rgba(0,0,0,0.04)",
                              fontWeight: 700,
                              borderRadius: 2,
                            }}
                          />
                        </Stack>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

/******************************************************************
 * COMPONENT: KumesCard
 ******************************************************************/
function KumesCard({ kumes, chartData, onGoDetail, onGoHistory }) {
  const isClosed = (kumes.URETIM_KAPANDI_MI || "H") === "E";
  const hasActiveDonem = !!kumes.DONEM_ID;
  const isIntegrated = !!kumes.ENTEGRASYON_KODU || !!kumes.URETICI_ENTEGRASYON_KODU;

const cinsiyet =
  kumes.HAYVAN_CINS_ID === 1
    ? null
    : kumes.CINSIYET_ID === 1
      ? "Erkek"
      : kumes.CINSIYET_ID === 2
        ? "Dişi"
        : "Cinsiyet Bilinmiyor";

  // Grafik progress
  const gunProgress = (Number(kumes.KACINCI_GUN) / 150) * 100; // 150 gün max kabul

  return (
      <Card
        elevation={0}
        sx={{
          width: "100%",
          height: "100%",
          minHeight: { xs: 420, md: 500 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRadius: 4,
          border: "1px solid rgba(0,0,0,0.06)",
          overflow: "hidden",
          background: "linear-gradient(180deg, #FFFFFF 0%, #FBFBFD 100%)",
          transition: "all 0.3s ease",
          boxShadow: "0 8px 22px rgba(15,23,42,0.08)",
          "&:hover": {
            boxShadow: "0 14px 30px rgba(0,0,0,0.12)",
            transform: "translateY(-4px)",
          },
        }}
      >
      {/* Header gradient */}
      <Box
        sx={{
          p: 2,
          pb: 1.5,
          background: `linear-gradient(135deg, ${ORANGE}10 0%, ${ORANGE}08 100%)`,
          position: "relative",
          overflow: "hidden",
        }}
      >

        <Box
          sx={{
            position: "absolute",
            top: -20,
            right: -20,
            width: 100,
            height: 100,
            borderRadius: "50%",
            bgcolor: `${"#a3a3a3"}10`,
          }}
        />

        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1} sx={{ position: "relative" }}>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography sx={{ fontWeight: 900, fontSize: 18, mb: 0.5 }} noWrap>
              {fmt(kumes.KUMES_ADI)}
            </Typography>

            <Stack direction="row" spacing={0.5} sx={{ flexWrap: "wrap", gap: 0.5 }}>
              {kumes.AKTIF_DONEM_PROJE_KODU && (
                  <Chip
                    size="small"
                    label={`Proje: ${fmt(kumes.AKTIF_DONEM_PROJE_KODU, "Proje Bilinmiyor")}`}
                    sx={{
                      bgcolor: "rgba(139,92,246,0.12)",
                      color: "#6D28D9",
                      fontWeight: 800,
                      borderRadius: 2,
                      fontSize: 11,
                      height: 22,
                    }}
                  />
                )}
              <Chip
                size="small"
                label={fmt(kumes.HAYVAN_TANIM_ADI, "Hayvan Türü Bilinmiyor")}
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 2,
                  fontWeight: 700,
                  fontSize: 11,
                  height: 22,
                }}
              />
              {cinsiyet && (
                <Chip
                  size="small"
                  label={cinsiyet}
                  sx={{
                    bgcolor: "#fff",
                    borderRadius: 2,
                    fontWeight: 700,
                    fontSize: 11,
                    height: 22,
                  }}
                />
              )}
              <Chip
                size="small"
                icon={isIntegrated ? <BusinessOutlinedIcon sx={{ fontSize: 12 }} /> : null}
                label={isIntegrated ? "Entegre" : "Manuel"}
                sx={{
                  bgcolor: isIntegrated ? "rgba(33,150,243,0.12)" : "rgba(76,175,80,0.12)",
                  color: isIntegrated ? "#1976d2" : "#2e7d32",
                  fontWeight: 800,
                  borderRadius: 2,
                  fontSize: 11,
                  height: 22,
                }}
              />
              <Chip
                size="small"
                label={hasActiveDonem ? (isClosed ? "Kapalı" : "Aktif") : "Dönem Yok"}
                sx={{
                  bgcolor: hasActiveDonem
                    ? isClosed
                      ? "rgba(244,67,54,0.12)"
                      : "rgba(76,175,80,0.12)"
                    : "rgba(158,158,158,0.12)",
                  color: hasActiveDonem ? (isClosed ? "#d32f2f" : "#2e7d32") : "text.secondary",
                  fontWeight: 800,
                  borderRadius: 2,
                  fontSize: 11,
                  height: 22,
                }}
              />
            </Stack>
          </Box>

          <Tooltip title={`${fmt(kumes.IL_ADI)} / ${fmt(kumes.ILCE_ADI)}`}>
            <Chip
              icon={<PlaceOutlinedIcon sx={{ fontSize: 14 }} />}
              size="small"
              label={fmt(kumes.IL_ADI)}
              sx={{
                bgcolor: "#fff",
                borderRadius: 2,
                fontWeight: 700,
                fontSize: 11,
                height: 24,
              }}
            />
            <Chip 
              size="small"
              label={fmt(kumes.IOT_DURUMU === "E" ? "IoT Aktif" : "IoT Pasif")}
              sx={{ 
                bgcolor: kumes.IOT_DURUMU === "E" ? "rgba(75, 243, 33, 0.12)" : "rgba(175, 76, 76, 0.12)",
                color: kumes.IOT_DURUMU === "E" ? "#2e7d32" : "#ff0000",
                borderRadius: 2,
                fontWeight: 700,
                fontSize: 11,
                height: 24,
                ml: 0.5,
              }}
            />
          </Tooltip>
        </Stack>
      </Box>

      <CardContent
        sx={{
          p: 2.2,
          pt: 1.8,
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        {/* Progress bar - Dönem günü */}
        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 700, color: "text.secondary" }}>
              Dönem İlerlemesi
            </Typography>
            <Typography sx={{ fontSize: 12, fontWeight: 900, color: ORANGE }}>
              {fmt(kumes.KACINCI_GUN)}. Gün
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={Math.min(gunProgress, 100)}
            sx={{
              height: 8,
              borderRadius: 4,
              bgcolor: "rgba(0,0,0,0.06)",
              "& .MuiLinearProgress-bar": {
                bgcolor: ORANGE,
                borderRadius: 4,
              },
            }}
          />
        </Box>

        {/* KPI Grid */}
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <MiniKpi
            icon={<PetsOutlinedIcon sx={{ fontSize: 20 }} />}
            label="Canlı Hayvan"
            fontSize={14}
            value={fmt(kumes.SON_BITIS_SAYI,"---")}
            color="#16A34A"
            highlight
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <MiniKpi
            icon={<CalendarTodayOutlinedIcon sx={{ fontSize: 20 }} />}
            label="Dönem No"
            value={fmt(kumes.DONEM_NO, "---")}
            color="#3B82F6"
            fontSize={14}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <MiniKpi
            icon={<HeartBrokenOutlinedIcon sx={{ fontSize: 20 }} />}
            label="Son Ölüm"
            fontSize={14}
            value={fmt(kumes.SON_OLUM, "---")}
            color="#EF4444"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <MiniKpi
            icon={<ThermostatOutlinedIcon sx={{ fontSize: 20 }} />}
            label="Sıcaklık"
            fontSize={14}
            value={`${round(kumes.SON_SICAKLIK, 1 )}°C`}
            color="#F59E0B"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <MiniKpi
            icon={<WaterDropOutlinedIcon sx={{ fontSize: 20 }} />}
            label="Nem"
            fontSize={14}
            value={`${round(kumes.SON_NEM, 0)}%`}
            color="#06B6D4"
          />
        </Grid>
      </Grid>

        {/* Mini grafikler */}
        {chartData.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    border: "1px solid rgba(0,0,0,0.06)",
                    bgcolor: "#fff",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "text.secondary", mb: 0.5 }}>
                    Sıcaklık Trendi
                  </Typography>
                  <ResponsiveContainer width="100%" height={40}>
                    <LineChart data={chartData}>
                      <Line type="monotone" dataKey="isi" stroke="#F59E0B" strokeWidth={2} dot={false} />
                    </LineChart>
                  </ResponsiveContainer>
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    border: "1px solid rgba(0,0,0,0.06)",
                    bgcolor: "#fff",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "text.secondary", mb: 0.5 }}>
                    Ölüm Trendi
                  </Typography>
                  <ResponsiveContainer width="100%" height={40}>
                    <LineChart data={chartData}>
                      <Line type="monotone" dataKey="olum" stroke="#EF4444" strokeWidth={2} dot={false} />
                    </LineChart>
                  </ResponsiveContainer>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        )}

        {/* Firma/Vet bilgisi */}
<Box
  sx={{
    p: 1.7,
    borderRadius: 2.5,
    bgcolor: "rgba(0,0,0,0.02)",
    border: "1px solid rgba(0,0,0,0.04)",
    mb: 2.2,
    minHeight: 145,
    display: "flex",
    alignItems: "center",
  }}
>
          <Stack spacing={0.8}>
            <InfoRow icon={<BusinessOutlinedIcon />} label="Firma" value={fmt(kumes.SIRKET_ADI, "Firma Bilinmiyor")} />
            <InfoRow icon={<MedicalServicesOutlinedIcon />} label="Veteriner" value={fmt(kumes.VETERINER_ADI, "Veteriner Bilinmiyor")} />
            <InfoRow icon={<LocalShippingOutlinedIcon />} label="Yem Fab." value={fmt(kumes.YEM_FABRIKA_ADI, "Yem Fabrikası Bilinmiyor")} />
            <InfoRow icon={<PetsOutlinedIcon />} label="Bölge" value={fmt(kumes.BOLGE_ADI, "Bölge Bilinmiyor")} />
            <InfoRow icon={<CalendarTodayOutlinedIcon />} label="Adres" value={fmt(kumes.ADRES, "Adres Bilinmiyor")} />
          </Stack>
        </Box>

        {/* Aksiyonlar */}
        <Stack direction="row" spacing={1} sx={{ mt: "auto" }}>
          <Button
            fullWidth
            variant="contained"
            disabled={!hasActiveDonem}
            onClick={onGoDetail}
            sx={{
              bgcolor: ORANGE,
              "&:hover": { bgcolor: ORANGE_HOVER },
              borderRadius: 2,
              fontWeight: 900,
              py: 1.2,
              textTransform: "none",
              fontSize: 13,
            }}
          >
            <TrendingUpIcon sx={{ fontSize: 18, mr: 0.5 }} />
            Detay Görünüm
          </Button>

          <Button
            variant="outlined"
            onClick={(e) => onGoHistory(e)}
            sx={{
              borderColor: "rgba(0,0,0,0.12)",
              color: ORANGE,
              borderRadius: 2,
              fontWeight: 900,
              textTransform: "none",
              py: 1.2,
              fontSize: 13,
              "&:hover": {
                borderColor: ORANGE,
                bgcolor: `${ORANGE}08`,
              },
            }}
          >
            <HistoryIcon sx={{ fontSize: 18, mr: 0.5 }} />
            Geçmiş Dönemler
          </Button>
          
        </Stack>
      </CardContent>
    </Card>
  );
}

function MiniKpi({ icon, label, value, color }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.2,
        borderRadius: 2,
        border: "1px solid rgba(0,0,0,0.06)",
        bgcolor: "#fff",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: 2,
            display: "grid",
            placeItems: "center",
            bgcolor: `${color}15`,
            color: color,
          }}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 10, color: "text.secondary", fontWeight: 600 }} noWrap>
            {label}
          </Typography>
          <Typography sx={{ fontWeight: 900, fontSize: 14 }} noWrap>
            {value}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
}

function InfoRow({ icon, label, value }) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box sx={{ color: ORANGE, display: "flex", fontSize: 14 }}>{icon}</Box>
      <Typography sx={{ fontSize: 11, color: "text.secondary", fontWeight: 600, minWidth: 70 }}>
        {label}:
      </Typography>
      <Typography sx={{ fontSize: 11, fontWeight: 700, flex: 1 }} noWrap>
        {value}
      </Typography>
    </Stack>
  );
}

const fmt = (v, fallback = "-") =>
  v === null || v === undefined || v === "" ? fallback : String(v);

const round = (v, d = 1) => {
  const n = Number(v);
  if (Number.isNaN(n)) return "-";
  return n.toFixed(d);
};

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Günaydın";
  if (hour < 18) return "İyi Günler";
  return "İyi Akşamlar";
};

const getBgGradient = () => {
  const hour = new Date().getHours();
  if (hour < 12) return `url(${sabahGorsel})`;
  if (hour < 18) return `url(${oglenGorsel})`;
  return `url(${aksamGorsel})`;
};

